module.exports = __webpack_public_path__ + "img/26.b9f82b44.jpg";